import React, {  Component } from 'react';

export default class ActionForSDSOverlayDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('ActionForSDSOverlayDialog', false);
    }

    componentDidMount() {
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="actionForSDSOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow" >
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Action</h2>
                    <p><b>Please remove items from this order to meet the 26 point <br/> maximum or create multiple deliveries with different dates.</b></p>
                    <div className="yesButtonContainer" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                      	<a className="yesButton blueButton" onClick={this.closeDialog.bind(this)}>Ok</a>
                    </div>
            	</div>
			</div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/actionForSDSOverlayDialog.js